export default __webpack_public_path__ + "static/media/bnb-mobile.30fdf477.png";